export const BANNER_TEXT = {
  '/work': 'work:// designed to be built, built to be used.',
  '/store': 'store:// merch for people who ask “what typeface is that?”',
  '/contact': 'contact:// if you’ve got a vision, we’ve got questions',
  '/about': 'about:// what we stand on, and what we stand for',
  '/read': 'read:// building in the open, thinking out loud',
} as const
